// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5171":"f00ce85d0d5c8667","8245":"a9978eeab728843a"}[chunkId] + ".js";
};